import React from "react";
import { Container } from "./style";
import { useTranslation } from "react-i18next";
const Com2 = () => {
  const { t } = useTranslation("sketchWallet");
  return (
    <Container>
      <div>{t("2-1")}</div>
      <div>
        <span>{t("2-2")}</span>
        <span>{t("2-3")}</span>
      </div>
    </Container>
  );
};

export default Com2;
